import React, { Fragment } from "react";
import { Toaster } from "react-hot-toast";
import AppNavigator from "./services/context";

console.log("Application Loaded")

interface ToastOptions {
  className: string;
  style: {
    margin: string;
    background: string;
    color: string;
    zIndex: number;
  };
  duration: number;
  success?: {
    duration: number;
    style: {
      textAlign: string;
      background: string;
    };
  };
  error?: {
    style: {
      textAlign: string;
      background: string;
    };
    duration: number;
  };
}

const App: React.FC = () => {
  return (
    <Fragment>
      <Toaster
        position="top-center"
        reverseOrder={false}
        toastOptions={{
          // Define default options
          className: "",
          style: {
            margin: "40px",
            background: "#363636",
            color: "#fff",
            zIndex: 1,
          },
          duration: 4000,
          // Default options for specific types
          success: {
            duration: 4000,
            style: {
              textAlign: "center",
              background: "#4caf50",
            },
          },
          error: {
            style: {
              textAlign: "center",
              background: "#f44336",
            },
            duration: 4000,
          },
        }}
      />
      <AppNavigator />
    </Fragment>
  );
};

export default App;
